module.exports = __webpack_public_path__ + "img/icon_home_ai_logo_1.07c1d03a.gif";